import React from 'react'
import EmployeeProjectNavbar from '../../../Components/EmployeeProjectNavbar'
import { Outlet, useLocation } from 'react-router-dom'

function EmpProjectView() {
    const location = useLocation();
    return (
        <>
            {location?.pathname?.includes("/project/employeeproject") ? (
                    <div className=''>
                        <div >
                            <EmployeeProjectNavbar />
                        </div>

                        <div className='mt-4'>
                            <Outlet />
                        </div>
                    </div>
            ) : (
                <div className=''>
                    <div >
                        <EmployeeProjectNavbar />
                    </div>

                    <div className='mt-4'>
                        <Outlet />
                    </div>
                </div>
            )}
        </>
    )
}

export default EmpProjectView;